export * from './lib/app-client-project-wiki-list-data-access.module';
